import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { Observable, empty } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { InterceptorSkipHeader } from './http-interceptor-skipheader.model';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
// import { AmbienteService } from '../multi-tenancy/ambiente.service';
// import { Ambiente } from '../multi-tenancy/ambiente.model';
import { ToasterService } from './toaster/toaster.service';
import { InterceptorPreLogin } from './http-interceptor-prelogin';
import { AmbienteConfig } from '../multi-tenancy/ambiente.config';


@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  // private ambiente: Ambiente = null;
  private keyDS  = '';
  private apiURL = '';

  private exibirLoadingPorRequisicao = false;
  private toasterId = 0;

  constructor(
      private autenticacaoService: AutenticacaoService
      // , private ambienteService: AmbienteService
      , private toasterService: ToasterService
  ) {

    if ( !this.keyDS ) {
      this.keyDS = AmbienteConfig.getKeyDS();
    }

    if ( !this.apiURL ) {
      this.apiURL = AmbienteConfig.getApiURL();
    }

    // this.ambiente = this.ambienteService.getAmbiente();
    // if ( this.ambiente ) {
    //   this.keyDS = this.ambiente.getKeyDS();
    // }

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (req.headers.has( InterceptorSkipHeader )) {
          const headers = req.headers.delete(InterceptorSkipHeader);
          return next.handle(req.clone({ headers }));
      }
      else if (req.headers.has( InterceptorPreLogin )) {
        const headers = req.headers.delete(InterceptorPreLogin);
        const apiRequest = req.clone({ headers })
                              .clone({url: `${this.apiURL}${req.url}`})
                              .clone({setHeaders: {'KeyDS': this.keyDS}});
        return next.handle(apiRequest);        
      }
      else {
        if ( this.exibirLoadingPorRequisicao ) {
          this.toasterId = this.toasterService.loading()
        }

        return this.fazerRequisicao(req, next);
      }
    }

    fazerRequisicao(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const authToken = this.autenticacaoService.getTokenDeAcessoValido();
      if ( authToken ) {
        let apiRequest = req.clone({url: `${this.apiURL}${req.url}`})
                              .clone({setHeaders: { Authorization: 'Bearer ' + authToken, 'KeyDS': this.keyDS}
                            });

        if ( this.toasterId > 0 ) {
          this.toasterService.clearWait(this.toasterId);
        }

        return next.handle(apiRequest);
      }
      else {
        return this.autenticacaoService
            .getTokenDeAcessoPeloRefreshToken()
            .pipe (
              switchMap (accessTokenNovo => {
                if (accessTokenNovo) {
                  const apiRequest = req.clone({url: `${this.apiURL}${req.url}`})
                                        .clone({setHeaders: { Authorization: 'Bearer ' + accessTokenNovo, 'KeyDS': this.keyDS}
                                      });
                  return next.handle(apiRequest);
                }
                else {
                  this.toasterService.warning('Sua sessão expirou. Favor refazer o login!');
                }
              })
              , catchError ( (error: any) => {
                  console.error(error);
                  this.toasterService.error('Ocorreu um erro ao recuperar sua chave de acesso', JSON.stringify(error));
                  return empty();
              })
            );
      }
    }
  }
